<template>
  <div class="user-invite-view">
      <b-container>
        <UserInviteForm
          @invite-sent="handleInviteSent"
          @invite-error="handleInviteError"
        />
      </b-container>
  </div>
</template>

<script>
import UserInviteForm from '@/components/UserInviteForm.vue'

export default {
  name: 'UserInvite',
  components: {
    UserInviteForm
  },
  methods: {
    handleInviteSent(success) {
      if (success) {
          this.$router.push('/admin/invite-users');
      }
    },
    handleInviteError(error) {
      // You can add a toast notification here
      alert('Error sending invite: ' + error)
    }
  }
}
</script>

<style scoped>
.user-invite-view {
  padding: 20px;
}
</style>
